import DestacatVisual from './DestacatVisual';
import DestacatVisualColumna from './DestacatVisualColumna';

export default function Component(props) {
    const { numColumnsRow } = props;
    return numColumnsRow > 0 && numColumnsRow < 12 ? <DestacatVisualColumna {...props} /> : <DestacatVisual {...props} />;
}
